export const guessTextColor = (bgHex: any) => {

    bgHex = String(bgHex).replace(/[^0-9a-f]/gi, '');
    if (bgHex.length < 6) {
        bgHex = bgHex[0] + bgHex[0] + bgHex[1] + bgHex[1] + bgHex[2] + bgHex[2];
    }
    
    var rgb = parseInt(bgHex, 16);   // convert rrggbb to decimal
    var r = (rgb >> 16) & 0xff;  // extract red
    var g = (rgb >> 8) & 0xff;  // extract green
    var b = (rgb >> 0) & 0xff;  // extract blue

    let alphaHex = 'ff';
    if (bgHex.length > 6) {
        alphaHex = bgHex.substring(6, 8);
        bgHex = bgHex.substring(0, 6);
    }

    let alpha = parseInt(alphaHex, 16) / 255;
    if (alpha < 0.3) {
        return "#000";
    }

    var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

    return luma > 164 ? "#292D32" : "#fff";

}